import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Button,
  CssBaseline,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import ReceiptIcon from "@mui/icons-material/Receipt";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate, Link } from "react-router-dom";
import useLiveLocation from "./useLiveLocation";
import DownloadIcon from "@mui/icons-material/Download";


const Header2 = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { location, loading } = useLiveLocation();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const shopkeeperName = user.shopName || user.name || "Shopkeeper";
  const profileImg = user.profileImageUrl || "";

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/MyAccountsSignIn");
  };

  const handleProfileUpdate = () => {
    navigate("/updateprofile");
    setAnchorEl(null);
  };

  const handleAccountSettings = () => {
    navigate("/MyAccountSetting");
    setAnchorEl(null);
    setMobileOpen(false);
  };

  const handleMenuClick = (route) => {
    const shopkeeperID = localStorage.getItem("shopkeeperID");
    if (route === "/orderreports") {
      navigate(`/orderreports/${shopkeeperID}`);
    } else {
      navigate(route);
    }
    setAnchorEl(null);
    setMobileOpen(false);
  };
const handleDownloadAPK = () => {
  const link = document.createElement("a");
  link.href = "/apk/sakhisshop.apk"; // path from public folder
  link.download = "SakhiShop.apk";
  link.click();
};

  // 📱 Mobile Drawer Menu
 const drawer = (
  <Box
    sx={{
      width: 250,
      bgcolor: "#f9f9f9",
      height: "100%",
    }}
    role="presentation"
    onClick={() => setMobileOpen(false)}
  >
    {/* HEADER */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        px: 4,
        py: 8,
        bgcolor: "#1b5e20",
        color: "#fff",
      }}
    >
      <Avatar
        src={profileImg}
        sx={{
          width: 48,
          height: 48,
          bgcolor: "#4caf50",
          fontWeight: 700,
        }}
      >
        {shopkeeperName?.charAt(0)?.toUpperCase()}
      </Avatar>

      <Box sx={{ overflow: "hidden" }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {shopkeeperName}
        </Typography>
        <Typography variant="caption" sx={{ color: "#c8e6c9" }}>
          Shopkeeper
        </Typography>
      </Box>
    </Box>

    <Divider />

    {/* MENU */}
    <List sx={{ px: 1 }}>
      <ListItem button onClick={() => handleMenuClick("/")}>
        <HomeIcon sx={{ mr: 1.5, color: "#1b5e20" }} />
        <ListItemText primary="Home" />
      </ListItem>

      <ListItem button onClick={() => handleMenuClick("/updateprofile")}>
        <PersonIcon sx={{ mr: 1.5, color: "#1b5e20" }} />
        <ListItemText primary="Profile Update" />
      </ListItem>

      <ListItem button onClick={handleAccountSettings}>
        <SettingsIcon sx={{ mr: 1.5, color: "#1b5e20" }} />
        <ListItemText primary="Account Settings" />
      </ListItem>

      <Divider sx={{ my: 1 }} />

      <ListItem button onClick={handleLogout}>
        <LogoutIcon sx={{ mr: 1.5, color: "red" }} />
        <ListItemText primary="Logout" />
      </ListItem>
    </List>
  </Box>
);

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          bgcolor: "#1b5e20",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          zIndex: (theme) => theme.zIndex.drawer + 2,
        }}
      >
        <Toolbar
          sx={{
            px: { xs: 2, sm: 4 },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Left Section: Logo + Mobile Menu */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {isMobile && (
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            )}
   {/* <Link to="/" style={{ textDecoration: "none" }}>
  <Box
    component="img"
    src={Grocerylogo}
    alt="Grocery Logo"
    sx={{
      height: { xs: 45, sm: 55 },
      width: "auto",
      objectFit: "contain",
      cursor: "pointer",
      transition: "transform 0.3s ease",
      "&:hover": { transform: "scale(1.05)" },
    }}
  />
</Link> */}

<Box
  component="img"
  src="/images/Grocerylogo.png"
  alt="Grocery Logo"
  sx={{
    height: { xs: 45, sm: 55 },
    width: "auto",
    objectFit: "contain",
      cursor: "pointer",
      transition: "transform 0.3s ease",
  }}
/>
          </Box>
         {/* Right Section: Welcome + Location + Avatar */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 1, sm: 2 },
            }}
          >
            <Button
  variant="contained"
  startIcon={<DownloadIcon />}
  onClick={handleDownloadAPK}
  sx={{
    ml: 2,
    background: "linear-gradient(45deg, #2cd62c, #0c6622)",
    color: "#fff",
    fontWeight: "bold",
    borderRadius: "8px",
    textTransform: "none",
    "&:hover": {
      background: "linear-gradient(45deg, #ff5722, #e64a19)",
    },
  }}
>
  Download App
</Button>
 
            {!isMobile && (
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 500,
                  fontSize: { xs: 12, sm: 14 },
                  fontFamily: "Poppins",
                }}
              >
                👋 Welcome, {shopkeeperName}
              </Typography>
            )}

            <Button
              sx={{
                color: "#fff",
                textTransform: "none",
                fontSize: { xs: "12px", sm: "13px" },
              }}
            >
              📍{" "}
              {loading ? (
                <CircularProgress size={16} sx={{ color: "white", ml: 1 }} />
              ) : (
                <Box component="span" sx={{ ml: 1 }}>
                  {location || "Set Location"}
                </Box>
              )}
            </Button>

            <IconButton
              color="inherit"
              onClick={handleAccountSettings}
              aria-label="open account settings"
            >
              <SettingsIcon />
            </IconButton>

            {/* Avatar Menu */}
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
              <Avatar
                src={profileImg}
                sx={{
                  bgcolor: "#4caf50",
                  width: 36,
                  height: 36,
                  border: "2px solid white",
                }}
              >
                {shopkeeperName?.charAt(0)?.toUpperCase()}
              </Avatar>
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={handleProfileUpdate}>
                <PersonIcon fontSize="small" sx={{ mr: 1 }} /> Profile Update
              </MenuItem>
              <MenuItem onClick={handleAccountSettings}>
                <SettingsIcon fontSize="small" sx={{ mr: 1 }} /> Account Settings
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon fontSize="small" sx={{ mr: 1, color: "red" }} />{" "}
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 250,
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Header2;
